import React, { useState } from "react"

// Manually add an app (App Setup, doc 04). Collapsed to a button; expands to a
// name field. `onCreate(name)` POSTs and resolves with the new app row so the
// parent can prepend it. Owner/admin gating is enforced server-side; a
// forbidden response surfaces through the error copy.
//
// This is the only add path: the Partner API's QueryRoot has no org-level
// "list apps" field (only a single-app-by-id lookup), so a Shopify picker
// isn't buildable against the real API.
export function AddAppForm({ copy, onCreate }) {
  const [open, setOpen] = useState(false)
  const [name, setName] = useState("")
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(false)
  const add = copy.add

  const reset = () => {
    setName("")
    setError(false)
    setBusy(false)
    setOpen(false)
  }

  const submit = (e) => {
    e.preventDefault()
    if (!name.trim()) return
    setBusy(true)
    setError(false)
    onCreate(name.trim())
      .then(reset)
      .catch(() => {
        setError(true)
        setBusy(false)
      })
  }

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700 active:scale-95 transition-all"
      >
        {add.button}
      </button>
    )
  }

  return (
    <form
      onSubmit={submit}
      className="rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:flex sm:items-end sm:gap-3"
    >
      <div className="flex-1">
        <label htmlFor="add-app-name" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          {add.nameLabel}
        </label>
        <input
          id="add-app-name"
          type="text"
          value={name}
          autoFocus
          onChange={(e) => setName(e.target.value)}
          placeholder={add.namePlaceholder}
          className="mt-1 w-full rounded-lg border border-gray-300 dark:border-gray-700 px-3 py-2 text-sm"
        />
        {error && <p className="mt-1 text-xs text-red-600 dark:text-red-400">{add.error}</p>}
      </div>
      <div className="mt-3 flex gap-2 sm:mt-0">
        <button
          type="submit"
          disabled={busy || !name.trim()}
          className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-50"
        >
          {busy ? add.submitting : add.submit}
        </button>
        <button
          type="button"
          onClick={reset}
          className="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800"
        >
          {add.cancel}
        </button>
      </div>
    </form>
  )
}
